import React from "react";
import Button from '@material-ui/core/Button';

export default (props) => (
  <div className='container-loading'>
    <div className="logo"><a href="https://www.epiqglobal.com.au" target="_blank" rel="noopener noreferrer"><img src="logo.svg" alt='EPIQ GLOBAL' /></a></div>
    <h3 className="message">Sorry, Page not Found.</h3>
    <Button color="primary" variant="contained">return to home page</Button>
  </div>
);
